var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowDownSmall = function SvgArrowDownSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "social-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.858,
    height: 5.866
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "arrow dow copy 5",
    d: "M.239.242a.807.807 0 0 1 1.062-.08l.091.08 3.536 3.627L8.464.242a.807.807 0 0 1 1.063-.08l.091.08a.836.836 0 0 1 .079 1.077l-.079.092-4.113 4.212a.807.807 0 0 1-1.062.08l-.091-.08L.239 1.411a.835.835 0 0 1 0-1.169Z"
  })));
};
export default SvgArrowDownSmall;